import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-123f98f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","height":"100%","margin-right":"auto"} }
const _hoisted_2 = {
  class: "headline-5 px-3",
  style: {"margin":"auto 0px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption ma-0" }, "Filter by region:", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Please try a different search or region. ")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "ml-2 mt-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Try a different search. ")
const _hoisted_8 = {
  class: "flex",
  style: {"height":"500px","flex-direction":"column"}
}
const _hoisted_9 = { class: "auto" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "ion-text-center w100 headline-5" }, " Help us find locations around you. Your location information will not be stored, and will only be used to help find services near you. ", -1))
const _hoisted_11 = { class: "w100 pa-4 flex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "px-4 headline-5" }, "Note", -1))
const _hoisted_13 = { class: "px-4" }
const _hoisted_14 = { class: "px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_notification_bell = _resolveComponent("notification-bell")!
  const _component_help_button = _resolveComponent("help-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_highlight_contact_item = _resolveComponent("highlight-contact-item")!
  const _component_contact_list_item = _resolveComponent("contact-list-item")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_contact_google_map = _resolveComponent("contact-google-map")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { onClick: _ctx.scrollTop }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, {
                slot: "start",
                class: "ion-hide-lg-up"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_back_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_notification_bell, {
                    parent: _ctx.$parent!.$refs.ionRouterOutlet
                  }, null, 8, ["parent"]),
                  _createVNode(_component_help_button)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { ref: "content" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, { class: "pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-hide-md-down px-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      class: "flex"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("contacts.title")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.innerWidth > 768)
                  ? (_openBlock(), _createBlock(_component_ion_row, {
                      key: 0,
                      class: "mx-4 pa-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_searchbar, {
                          autocorrect: "on",
                          spellcheck: "",
                          modelValue: _ctx.search,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                          placeholder: "Search",
                          color: "white",
                          debounce: "500",
                          onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterBySearch())),
                          enterkeyhint: "enter",
                          "show-cancel-button": "never",
                          inputmode: "search",
                          onKeyup: _withKeys(_ctx.closeMe, ["enter"])
                        }, null, 8, ["modelValue", "onKeyup"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.myRegionId != null && _ctx.myRegionId != undefined && _ctx.contacts)
                  ? (_openBlock(), _createBlock(_component_ion_row, {
                      key: 1,
                      class: "mx-4 pa-4 ion-hide-md-down"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.myRegionId != null && _ctx.myRegionId != undefined && _ctx.regions)
                  ? (_openBlock(), _createBlock(_component_ion_row, {
                      key: 2,
                      class: "mx-4 px-4 ion-hide-md-down"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region) => {
                          return (_openBlock(), _createBlock(_component_ion_chip, {
                            color: "dark",
                            onClick: ($event: any) => (_ctx.filterByRegion(region)),
                            outline: !_ctx.selectedRegion || _ctx.selectedRegion.name != region.name,
                            key: region.id + '-region'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { color: "dark" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(region.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "outline"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (
              _ctx.myRegionId != null && _ctx.myRegionId != undefined && _ctx.innerWidth > 768
            )
                  ? (_openBlock(), _createBlock(_component_ion_row, {
                      key: 3,
                      class: "pa-4 mt-4 ion-justify-content-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          class: "pa-0 shadow-element list-order",
                          size: "4",
                          "size-xs": "12",
                          "size-sm": "4",
                          style: {"max-height":"500px"}
                        }, {
                          default: _withCtx(() => [
                            (!_ctx.highlightContact && _ctx.contacts && _ctx.contacts.length == 0)
                              ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                                  default: _withCtx(() => [
                                    (!_ctx.loading)
                                      ? (_openBlock(), _createBlock(_component_ion_item, {
                                          key: 0,
                                          lines: "none"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                              default: _withCtx(() => [
                                                _hoisted_4
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.loading)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mocks, (block) => {
                                            return (_openBlock(), _createBlock(_component_ion_item, {
                                              lines: "none",
                                              key: block + '-block'
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_thumbnail, { slot: "end" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_skeleton_text, { style: {"border-radius":"50%"} })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_label, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("h3", null, [
                                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"50%"} })
                                                    ]),
                                                    _createElementVNode("p", null, [
                                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"40%"} })
                                                    ]),
                                                    _createElementVNode("p", null, [
                                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"70%"} })
                                                    ]),
                                                    _createElementVNode("p", null, [
                                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"80%"} })
                                                    ]),
                                                    _createElementVNode("p", null, [
                                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"80%"} })
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.highlightContact)
                              ? (_openBlock(), _createBlock(_component_highlight_contact_item, {
                                  key: 1,
                                  class: "ion-hide-md-down",
                                  style: {"max-height":"500px","overflow-y":"scroll"},
                                  highlightContact: _ctx.highlightContact,
                                  onClearHighlight: _cache[2] || (_cache[2] = ($event: any) => (_ctx.highlightContact = null)),
                                  onFilterSearch: _cache[3] || (_cache[3] = 
                  ($event) => {
                    _ctx.search = $event;
                    _ctx.filterBySearch();
                  }
                )
                                }, null, 8, ["highlightContact"]))
                              : _createCommentVNode("", true),
                            (
                  _ctx.myRegionId != null &&
                  _ctx.myRegionId != undefined &&
                  !_ctx.highlightContact &&
                  _ctx.contacts &&
                  _ctx.contacts.length > 0 &&
                  _ctx.innerWidth > 768
                )
                              ? (_openBlock(), _createBlock(_component_ion_content, {
                                  key: 2,
                                  class: "ion-hide-md-down"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_list, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (contact) => {
                                          return (_openBlock(), _createBlock(_component_contact_list_item, {
                                            contact: contact,
                                            onGoto: ($event: any) => {
                      _ctx.goToMarker(
                        _ctx.markers.find((m) => m.contact.id == contact.id)
                      );
                      _ctx.highlightContact = contact;
                    },
                                            key: contact.id + '-contact'
                                          }, null, 8, ["contact", "onGoto"]))
                                        }), 128)),
                                        _createVNode(_component_ion_infinite_scroll, {
                                          onIonInfinite: _ctx.loadMore,
                                          threshold: "200px",
                                          id: "infinite-scroll"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_infinite_scroll_content, { "loading-spinner": "crescent" })
                                          ]),
                                          _: 1
                                        }, 8, ["onIonInfinite"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          class: "pa-0 map-order",
                          size: "8",
                          "size-xs": "12",
                          "size-sm": "8"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_contact_google_map, {
                              center: _ctx.centerPoint,
                              markers: _ctx.markers,
                              zoom: _ctx.zoom,
                              find: "",
                              onFindme: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setLocation())),
                              onGoto: _cache[5] || (_cache[5] = ($event: any) => {
                  _ctx.goToMarker($event);
                  _ctx.setHighlight($event);
                  _ctx.hideResults = false;
                })
                            }, null, 8, ["center", "markers", "zoom"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.innerWidth <= 768)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_contact_google_map, {
                          center: _ctx.centerPoint,
                          markers: _ctx.markers,
                          zoom: _ctx.zoom,
                          find: "",
                          onFindme: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setLocation())),
                          onGoto: _cache[13] || (_cache[13] = ($event: any) => {
                _ctx.goToMarker($event);
                _ctx.setHighlight($event);
                _ctx.hideResults = false;
              }),
                          height: 'calc(100vh - 72px - 56px)'
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_ion_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_searchbar, {
                                    autocorrect: "on",
                                    spellcheck: "",
                                    modelValue: _ctx.search,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.search) = $event)),
                                    placeholder: "Search",
                                    debounce: "500",
                                    onIonChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterBySearch())),
                                    enterkeyhint: "enter",
                                    "show-cancel-button": "never",
                                    inputmode: "search",
                                    onKeyup: _withKeys(_ctx.closeMe, ["enter"]),
                                    onIonFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideResults = false))
                                  }, null, 8, ["modelValue", "onKeyup"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card, { style: {"margin":"8px","margin-top":"0px"} }, {
                                default: _withCtx(() => [
                                  (_ctx.highlightContact && !_ctx.hideResults)
                                    ? (_openBlock(), _createBlock(_component_highlight_contact_item, {
                                        key: 0,
                                        style: _normalizeStyle([{"height":"40vh","overflow-y":"scroll"}, {
                      'max-height': _ctx.hideResults ? '0vh' : '40vh',
                      height: _ctx.hideResults ? '0vh' : '40vh',
                    }]),
                                        highlightContact: _ctx.highlightContact,
                                        onClearHighlight: _cache[9] || (_cache[9] = ($event: any) => (_ctx.highlightContact = null)),
                                        onFilterSearch: _cache[10] || (_cache[10] = 
                      ($event) => {
                        _ctx.search = $event;
                        _ctx.filterBySearch();
                      }
                    )
                                      }, null, 8, ["style", "highlightContact"]))
                                    : _createCommentVNode("", true),
                                  (!_ctx.highlightContact)
                                    ? (_openBlock(), _createBlock(_component_ion_content, {
                                        key: 1,
                                        style: _normalizeStyle({
                      'max-height': _ctx.hideResults ? '0vh' : '30vh',
                      height: _ctx.hideResults ? '0vh' : '30vh',
                    })
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_list, { style: {"overflow-y":"scroll"} }, {
                                            default: _withCtx(() => [
                                              (_ctx.loading2 && _ctx.search && _ctx.contacts.length == 0)
                                                ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
                                                    key: 0,
                                                    class: "mx-4",
                                                    type: "indeterminate"
                                                  }))
                                                : _createCommentVNode("", true),
                                              (!_ctx.loading2 && _ctx.search && _ctx.contacts.length == 0)
                                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                                    key: 1,
                                                    lines: "none"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_7
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (contact) => {
                                                return (_openBlock(), _createBlock(_component_ion_item, {
                                                  button: "",
                                                  onClick: ($event: any) => {
                          _ctx.goToMarker(
                            _ctx.markers.find((m) => m.contact.id == contact.id)
                          );
                          _ctx.highlightContact = contact;
                        },
                                                  key: contact.id,
                                                  lines: "none"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, {
                                                      slot: "start",
                                                      size: "large",
                                                      icon: _ctx.personCircleOutline,
                                                      style: _normalizeStyle({
                            color:
                              'rgb(' +
                              _ctx.getColor(
                                contact.category ? contact.category.name : ''
                              ) +
                              ')',
                          })
                                                    }, null, 8, ["icon", "style"]),
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("p", null, _toDisplayString(contact.name), 1),
                                                        _createElementVNode("p", null, _toDisplayString(contact.designation) + " - " + _toDisplayString(contact.region ? contact.region.name : ""), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              }), 128)),
                                              _createVNode(_component_ion_infinite_scroll, {
                                                onIonInfinite: _ctx.loadMore,
                                                threshold: "100px",
                                                id: "infinite-scroll"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_infinite_scroll_content, { "loading-spinner": "crescent" })
                                                ]),
                                                _: 1
                                              }, 8, ["onIonInfinite"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["style"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", {
                              class: "toggle-box ionic-shadow flex",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.hideResults = !_ctx.hideResults))
                            }, [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.hideResults ? _ctx.chevronDown : _ctx.chevronUp,
                                size: "large",
                                class: "auto"
                              }, null, 8, ["icon"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["center", "markers", "zoom", "height"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.myRegionId == null || _ctx.myRegionId == undefined)
                  ? (_openBlock(), _createBlock(_component_ion_row, {
                      key: 5,
                      class: "ion-justify-content-center pt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          "size-xs": "10",
                          "size-sm": "8",
                          "size-md": "6",
                          "size-lg": "8",
                          size: "8"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _createElementVNode("div", _hoisted_11, [
                                  _createVNode(_component_ion_spinner, {
                                    style: {"transform":"scale(2)"},
                                    class: "auto",
                                    name: "crescent"
                                  })
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.myRegionId != null && _ctx.myRegionId != undefined)
                  ? (_openBlock(), _createBlock(_component_ion_row, {
                      key: 6,
                      class: "ion-hide-md-down"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          size: "8",
                          "size-xs": "12",
                          "size-sm": "12",
                          class: "pa-4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t("contacts.disclaimer1")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t("contacts.disclaimer2")), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}